import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom';
import classes from "./FailedPage.module.css";
import { AiOutlineCheckCircle, AiOutlineCloseCircle, AiOutlineLoading3Quarters } from 'react-icons/ai';
import { printLogsApi } from '../Http/http';

const FailedPage = () => {

    const [searchParams, setSearchParams] = useSearchParams();
    // const [msisdn, setMsisdn] = useState(null);
    // const [message, setMessage] = useState(null);
    const navigate = useNavigate();

    // useEffect(() => {
    //     if (searchParams.get("msisdn")) {
    //         setMsisdn(searchParams.get("msisdn"));
    //     }
    //     if (searchParams.get("message")) {
    //         setMessage(searchParams.get("message"));
    //     }
    // }, [searchParams]);

    const saveLogs = async () => {
        try {
            const response2 = await printLogsApi({ url: window.location.href });
            console.log(response2, 'response2...');
        } catch (error) {
            console.log(error, 'error---');
        }
    }
    useEffect(() => {
        saveLogs();
    }, []);


    // useEffect(() => {
    //     if (!msisdn) {
    //         return;
    //     }
    //     if (message == "Success" || message == `"Success"`) {
    //         Cookies.set('msisdn', msisdn, { expires: 1 });
    //         setTimeout(() => navigate('/home'), 3000);
    //     }
    // }, [message, msisdn]);

    return (
        <div className={classes.wrapper}>

            <div className={classes.statusContainer}>
                <AiOutlineCloseCircle className={classes.iconFailure} />
                <h2>Subscription Failed</h2>
                <p>We were unable to complete your subscription. Please try again.</p>
                <button type="button" className={classes.button} onClick={()=>navigate("/")}>Go Back</button>
            </div>
        </div>
    )
}

export default FailedPage


// 0|rashiGames_callback  | {"url":"https://ke.rashigames.com/redirect?requestid=6b7ec233-662a-4ecd-90a4-a3f9c6ec3765&mfilter_id=1751365255430wpjmb&msisdn=0724480213&message=Failure&error=invalid_traffic"} Front end logs----------->